import * as Yup from 'yup';

export const pondSchema = Yup.object({
  ponds: Yup.array(
    Yup.object({
      status: Yup.string().required('Campo Obrigatório'),
      description: Yup.string().required('Campo Obrigatório'),
      capacity: Yup.number().required('Campo Obrigatório'),
      depth: Yup.number().required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
      system: Yup.string().required('Campo Obrigatório'),
      protocol: Yup.string().required('Campo Obrigatório'),
    })
  ).min(1, 'Adicione pelo menos um viveiro'),
});
